export default __webpack_public_path__ + "static/media/photo5.930dd603.jpg";